<script>
  export default {
    name: 'JumpTem',
    props: {
      value: {
        type: Object,
        default: () => {}
      },
      clientType: {
        type: Number,
        default: 1 // 1为乘客端，2为司机端，3为云滴管家
      },
      mark: {
        // 用作ref标识
        type: String,
        default: 'default'
      },
      isDefaultBanner: {
        // 是否是默认banner
        type: Boolean,
        default: false
      }
    },
    model: {
      prop: 'value',
      event: 'change'
    },
    data() {
      return {
        rules: {
          pageUrl: [
            {
              validator: (rule, value, callback) => {
                if (!value) {
                  callback()
                  return
                }

                // 使用更精确的表情符号检测方法
                // 这个正则表达式专门匹配表情符号，不会误判数字
                const emojiRegex =
                  /[\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/u

                if (emojiRegex.test(value)) {
                  callback(new Error('名称不能包含表情符号'))
                  return
                }

                callback()
              },
              trigger: ['blur', 'change']
            }
          ],
          // pageUrlType: [{ required: true, message: '请选择跳转类型', trigger: 'change' }],
          displayChannelList: [
            { required: true, message: '请至少选择一个展示渠道', trigger: 'change' }
          ],
          appId: [
            { required: true, message: '请输入appId', trigger: 'blur' },
            { pattern: /^wx[a-z0-9]{16}/, message: 'appId输入有误', trigger: 'blur' }
          ],
          appletOriginalId: [
            { required: true, message: '请输入账号原始ID', trigger: 'blur' },
            { pattern: /^gh_[a-z0-9]{12}/, message: '账号原始ID输入有误', trigger: 'blur' }
          ]
        }
      }
    },
    computed: {
      form: {
        set(val) {
          this.$emit('change', val)
        },
        get() {
          return this.value
        }
      }
    },
    methods: {
      /**
       * 校验表单
       * @returns {Promise<Object>} - 返回校验结果，成功返回表单数据，失败返回错误信息
       */
      validateForm() {
        return new Promise((resolve, reject) => {
          const jumpTemp = this.$refs[this.mark + '_ruleForm']
          console.log('jumpTemp', jumpTemp)
          if (jumpTemp) {
            jumpTemp.validate((valid) => {
              if (valid) {
                // 处理表单数据
                const formData = { ...this.form }

                // 清理表单数据，移除空值
                if (formData.pageUrl) {
                  formData.pageUrl = formData.pageUrl.trim()
                }

                if (formData.appId) {
                  formData.appId = formData.appId.trim()
                }

                if (formData.displayChannelList && formData.displayChannelList.length > 0) {
                  formData.displayChannel = formData.displayChannelList.join(',')
                }

                resolve(formData)
              } else {
                reject(new Error('表单校验失败'))
              }
            })
          } else {
            reject(new Error(`找不到表单引用: ${this.mark}_ruleForm`))
          }
        })
      },

      /**
       * 重置表单
       */
      resetForm() {
        const jumpTemp = this.$refs[this.mark + '_ruleForm']
        jumpTemp && jumpTemp.resetFields()
      }
    }
  }
</script>

<template>
  <div class="jumpTem">
    <slot name="banner"></slot>
    <el-form
      :model="form"
      :ref="mark + '_ruleForm'"
      label-width="120px"
      size="small"
      :rules="rules"
    >
      <el-form-item
        v-if="clientType === 1 && !isDefaultBanner"
        label="展示渠道"
        prop="displayChannelList"
      >
        <el-checkbox-group v-model="form.displayChannelList">
          <el-checkbox label="1">微信小程序</el-checkbox>
          <el-checkbox label="2">APP</el-checkbox>
          <el-checkbox label="3">云闪付</el-checkbox>
          <el-checkbox label="4">支付宝小程序</el-checkbox>
          <!-- 暂时只在banner 使用 -->
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="跳转页面" prop="pageUrl">
        <el-input
          v-model.trim="form.pageUrl"
          placeholder="请输入链接"
          style="width: 300px"
          v-no-emoji
        />
      </el-form-item>
      <el-form-item v-if="clientType === 1" label="跳转类型" prop="pageUrlType">
        <el-radio-group v-model="form.pageUrlType">
          <el-radio :label="2">外部链接</el-radio>
          <el-radio :label="1">乘客端内部页面</el-radio>
          <el-radio :label="3" v-if="!isDefaultBanner">其他小程序（仅在微信小程序生效）</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form.pageUrlType === 3" label="APPID" prop="appId">
        <el-input
          v-model.trim="form.appId"
          placeholder="请输入APPID"
          style="width: 300px"
          v-no-emoji
        />
      </el-form-item>
      <el-form-item v-if="form.pageUrlType === 3" label="账号原始ID" prop="appletOriginalId">
        <el-input
          v-model.trim="form.appletOriginalId"
          placeholder="请输入账号原始ID"
          style="width: 300px"
          v-no-emoji
        />
      </el-form-item>
    </el-form>
  </div>
</template>

<style scoped lang="scss"></style>
